// @flow
import { logError } from '../../sentry';
import ANALYTICS from '../../analytics';

export const submitFeedback = async (feedbackBody: {
  contact: string,
  body: string,
  subject: string | null,
  country: string | null,
  selectedOptions: (string | null)[],
  name: string,
}): Promise<any> => {
  if (feedbackBody && feedbackBody.name) {
    ANALYTICS.feedbackSpam();
    return Promise.reject();
  }

  const method = 'POST';
  const action = '/landing_feedback';

  try {
    const init = {
      credentials: 'same-origin',
      headers: new Headers({
        Accept: 'application/json',
        'Content-Type': 'application/json; charset=utf-8',
      }),
    };

    const response = await fetch(new Request(action, init), {
      method,
      body: JSON.stringify({ ...feedbackBody, name: undefined }),
    }).then((resp) => {
      const { status } = resp;

      if (status >= 200 && status < 400) {
        return resp;
      }

      const error = new Error(`${resp.statusText} (${resp.url})`);

      // $FlowFixMe
      error.resp = resp;

      throw error;
    });

    if (response && response.ok) {
      ANALYTICS.feedbackSend(true);
      return Promise.resolve(response);
    }

    ANALYTICS.feedbackSend(false);
    return Promise.reject(response);
  } catch (e) {
    logError(e, { action, method, body: feedbackBody });
    ANALYTICS.feedbackSend(false);
    return Promise.reject(e);
  }
};
